<template>
    <div class="acomodar">
        <Cese/> 
    </div>
</template>

<script>
import Cese from '@/components/ModContratos/RegistroCese/RegCesIndividual.vue'
export default {
    name: 'SolimanologRegistroDeCeseIndividual',
    components:{
        Cese
    },

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>
